import { useEffect, useState } from "react";
import { EmailLeads, PublishActionComp, Social, TapToLearnShare } from "./publishActionComp"
import DepartmentSelectors from "../molecule/departmentSelector";
import { HorizontalLayout, VerticalLayout } from "./layout";
import { NavItem } from "../atoms/navItem";
import { IconButton } from "../atoms/buttons";
import { TapToLearnShareCampagne } from "./campagneCardLeads";
import EmailDepartmentSelector from "./campagneTableComp";

export function CampagneSocials({ data, step, onSwitchChange }) {
    const [activeScreen, setActiveScreen] = useState();
    const [isSwitchActive, setSwitchActive] = useState(false);
    const [hasInteracted, setHasInteracted] = useState(false);

    const handleToggle = () => {
    setHasInteracted(true);
    isSwitchActive ? setSwitchActive(false) : setSwitchActive(true)
    // setSwitchActive(prev => !prev);
     onSwitchChange(isSwitchActive)
    };

    

        const NavigationActions = ({ actions }) => {
        switch (actions) {
            case 1: return <Social data={data} />
            case 2: return <EmailLeads />
            case 3: return <DepartmentSelectors />
            case 4: return <TapToLearnShareCampagne data={data} step={step} />
            default: return null;
            }
        };

        const PublishNavigation = ({ activeScreen, onClick }) => {
            const navigation = [
            { id: 1, icon: "share" },
            { id: 2, icon: "mail" },
            { id: 3, icon: "department" },
            { id: 4, icon : "card"},
            ];

            return (
            <VerticalLayout
                className="publish-nav-campagne"
                style={{
                boxShadow: "rgba(0, 0, 0, 0.25) -1px 0px 4px",
                borderRadius: "0 calc(.8rem * var(--br-scale)) calc(.8rem * var(--br-scale)) 0",
                minHeight: "inherit",
                // height: "calc(100% + 3rem)",
                minWidth: "3.8rem"
                }}
            >
                {navigation.map((nav) => (
                <NavItem
                    key={nav.id}
                    style={{ width: "unset", justifyContent: "center", alignItems: "center", paddingLeft: "0.5rem" }}
                    onClick={() => (  isSwitchActive ? setSwitchActive(false) : setSwitchActive(true) , onClick(nav.id))}
                    icon2={nav.icon}
                    active={nav.id === activeScreen}
                />
                ))}
                <IconButton
                onClick={() => handleToggle()}
                className={`chevron-rotate ${hasInteracted ? (isSwitchActive ? "open" : "closed") : ""} standard-margin-bottom`}
                size={25}
                icon2={"chevron-right"}
                style={{ pointerEvents: activeScreen ? "auto" : "none", margin: "unset", color: "var(--white)" }}
                />
            </VerticalLayout>
            );
        };

        return (
            <>
            <HorizontalLayout className={`campagne-switch ${isSwitchActive && "active"}`}><NavigationActions actions={activeScreen} /></HorizontalLayout>
            <PublishNavigation activeScreen={activeScreen} onClick={(id) => { setActiveScreen(id); setSwitchActive(true); }} />
            </>
        );
        };
